<br>
<div class="overflow-auto">
  <app-common-list-table
    [request]="env.showSdiClientes ? getRequestSdi : getRequest"
    [cols]="env.showSdiClientes ? colsSdi : cols"
    [filtering]="filtering"
    [globalConditionalStyle]="globalConditionalStyle"
    [globalVisualTransform]="globalVisualTransform"
    [actionButtonText]="env.canAddClients ? 'Añadir ' + env.clienteName : ''"
    (actionButtonClick)="add()"
    [customExportCsv]="env.showClientesCsv"
    (visualize)="show('info', $event)"
    (edit)="edit($event)"
    [showExportCsv]="false"
    (remove)="show('delete', $event)">

    <!-- Header slot -->
    <ng-template #header>
      <div class="d-flex align-items-center gap-2 w-100">

        @if (env.applicationType === 'cropgest' && env.rol === 'admin') {
            <button
                type="button"
                class="btn btn-info btn-sm text-white ms-2 export-button"
                (click)="exportarClientes()"
            >
                <i class="fa fa-download"></i>
                <span class="ms-1">Exportar {{env.clientesName}}</span>
            </button>
        }

        @if (env.appName === 'hopsteiner') {
            <button
                type="button"
                class="btn btn-info btn-sm"
                (click)="downloadCsv()"
            >
                <i class="fa fa-download"></i>
                <span class="ms-1">Exportar listado</span>
            </button>
        }

        @if (env.showMostrarTodosClientes) {
            <div class="d-flex align-items-center">
                <p-inputSwitch
                    class="me-2"
                    [(ngModel)]="env.showAllClients"
                    (onChange)="changeShowAll(); filtering.filter();">
                </p-inputSwitch>
                <span class="text-white mb-0">Mostrar todos</span>
            </div>
        }

        @if (env.appName === 'agrotata') {
            <div class="d-flex align-items-center gap-2 ms-auto">
                <button
                    type="button"
                    class="btn btn-danger btn-sm text-white"
                    (click)="generarAdquisicion(currentClient!)"
                    [disabled]="!currentClient"
                    title="Generar PDF Registro de Adquisición"
                >
                    <i class="fa fa-file-pdf-o"></i>
                    <span class="ms-1">Adquisición</span>
                </button>

                <button
                    type="button"
                    class="btn btn-warning btn-sm text-white"
                    (click)="generarAplicacion(currentClient!)"
                    [disabled]="!currentClient"
                    title="Generar PDF Registro de Aplicación"
                >
                    <i class="fa fa-file-pdf-o"></i>
                    <span class="ms-1">Aplicación</span>
                </button>
            </div>
        }

      </div>
    </ng-template>

    <!-- Header extra columns -->
    <ng-template #thEnd>
        <th><p class="d-flex justify-content-center mb-0">Acciones</p></th>
        <th><p class="d-flex justify-content-center mb-0">{{ env.clientesName }}</p></th>
    </ng-template>

    <!-- Body extra columns -->
    <ng-template #tdEnd let-data>
      <td>
        <app-action-buttons
          [hideEdit]="!env.canEditClients"
          [hideDelete]="!env.canDeleteClients"
          (editRowButtonEvent)="edit(data.data)"
          (deleteRowButtonEvent)="unsetClientIfSelected(this.model.id); show('delete', data.data)"
          (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>

      <td>
        <div class="d-flex justify-content-center">
          <button
            type="button"
            (click)="selectClient(data.data)"
            class="d-flex justify-content-center align-items-center btn-client"
            [class.is-current]="data.data.id === currentClient?.id"
            [attr.aria-pressed]="data.data.id === currentClient?.id">
            <i
              class="fa"
              [class.fa-user]="data.data.id !== currentClient?.id"
              [class.fa-check]="data.data.id === currentClient?.id">
            </i>
            <span class="ms-1">{{ data.data.id !== currentClient?.id ? 'Seleccionar' : 'Actual' }}</span>
          </button>
        </div>
      </td>
    </ng-template>
  </app-common-list-table>
</div>

<app-modals
  [view]="this"
  [form]="form?.formFields"
  [serverUrl]="env.serverUrl"
  [previousData]="model"
  [recordHasAssociatedData]="model.tiene_datos"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest">
</app-modals>